/* eslint-disable no-console */
import { FC } from 'react';
import { GetServerSideProps } from 'next';
import Head from 'next/head';

import { SmartGridCollections } from '@components/smart-grid-collections';
import { API_LIMIT_PAGE_COLLECTIONS } from '@constants';

const Collections: FC = () => {
  return (
    <>
      <Head>
        <title>Collections</title>
      </Head>
      <main>
        <SmartGridCollections api="/api/public/collections" limit={API_LIMIT_PAGE_COLLECTIONS} />
      </main>
    </>
  );
};

export default Collections;

export const getServerSideProps: GetServerSideProps = async ({ res, locale }) => {
  res.setHeader('Cache-Control', 's-maxage=60, public');
  return {
    props: {
      messages: await import(`../../locales/${locale}.json`).then((e) => e.default),
    },
  };
};
